import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './context/ToastContext';
import { LoadingProvider } from './context/LoadingContext';
import { SidebarProvider } from './context/SidebarContext';
import { TimeModeProvider } from './context/TimeModeContext';
import ProtectedRoute from './components/ProtectedRoute';
import ToastContainer from './components/ToastContainer';
import LoadingOverlay from './components/LoadingOverlay';
import CelebrationPopup from './components/CelebrationPopup';
import Login from './screens/Login';
import Profile from './screens/Profile';
import CheckIn from './screens/CheckIn';
import WeeklyNotes from './screens/WeeklyNotes';
import AdminDashboard from './screens/AdminDashboard';
import TeamStatus from './screens/TeamStatus';
import Reports from './screens/Reports';
import Leaves from './screens/Leaves';
import Announcements from './screens/Announcements';
import HQ from './screens/HQ';

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ToastProvider>
        <LoadingProvider>
          <AppProvider>
            <SidebarProvider>
              <TimeModeProvider>
                <BrowserRouter>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute access="any">
                          <Profile />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/checkin"
                      element={
                        <ProtectedRoute access="any">
                          <CheckIn />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/weekly"
                      element={
                        <ProtectedRoute access="any">
                          <WeeklyNotes />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/team"
                      element={
                        <ProtectedRoute access="any">
                          <TeamStatus />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin"
                      element={
                        <ProtectedRoute access="admin">
                          <AdminDashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/reports"
                      element={
                        <ProtectedRoute access="admin">
                          <Reports />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/leaves"
                      element={
                        <ProtectedRoute access="any">
                          <Leaves />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/announcements"
                      element={
                        <ProtectedRoute access="any">
                          <Announcements />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/hq"
                      element={
                        <ProtectedRoute access="admin">
                          <HQ />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                  </Routes>
                  <ToastContainer />
                  <LoadingOverlay />
                  <CelebrationPopup />
                </BrowserRouter>
              </TimeModeProvider>
            </SidebarProvider>
          </AppProvider>
        </LoadingProvider>
      </ToastProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
